module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wxjS9i/tc-custom/FC-9781528962346.jpg?1692133193265?1705766068761",
      "alt": "This image is the cover for the book Wow, a Robot Club"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wow, a Robot Club\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A small group of children and their parents form The Robot Club. No one realised what impact this would have on their lives and what adventures they would have. Finn and the other clever children build robots and program them. The technology extends to drones, artificial intelligence and other new ideas. "), _c('br'), _vm._v("This is the first book in a series of adventures for this robot club.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janice Gunstone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Janice has four children and always wanted them to have an exciting childhood. They attended clubs of interest plus cubs, scouts and brownies. During her working life, she has spent time as a primary school teacher in kindergartens in China, worked in aboriginal communities and taught in a university. She completed her masters in innovation in education because her passion was always to engage and excite children with their education, especially reading interesting stories.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0